import React from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import OrgUnitTable from "./MastersScreen/OrgUnitTable";
import BranchTable from "./MastersScreen/BranchTable";
import Designation from "./MastersScreen/Designation";
import OutletTypeTable from "./MastersScreen/OutletTypeTable";
import LanguageTable from "./MastersScreen/LanguageTable";
type props = {};

const Masters = (props: props) => {
  const navigate = useNavigate();

  const NavigateToPolicyMaster = () => {
    navigate("/configuration/grademaster/policymaster");
  };
  return (
    <div className="p-2">
      <PageHeader title="Masters" />

      <div className="row mb-0 ">
        <div className="col-md-6">
          <OrgUnitTable />
        </div>

        <div className="col-md-6">
          <BranchTable />
        </div>
      </div>

      <div className="row mb-0 ">
        <div className="col-md-6">
          <Designation />
        </div>

        <div className="col-md-6">
          <OutletTypeTable />
        </div>

      </div>
      
      <div className="row mb-0 ">
        <div className="col-md-6">
          <LanguageTable />
        </div>
      </div>
    </div>
  );
};
export default Masters;
